module.exports = __webpack_public_path__ + "static/img/Nathan-Hindmarsh.8692852.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathan-Hindmarsh.jpg
// module id = mpWJ
// module chunks = 0